import React, { useEffect, useState, useRef, useMemo } from "react";
import { useDispatch, useSelector, connect } from "react-redux";
import SocketConnection from "../../utils/SocketConnection";
import "../../assets/css/chat.css";
import ReactHtmlParser from "react-html-parser";
import { getRandomInt } from "../../utils/commonFunction";
import { useHistory, useLocation } from "react-router-dom";
import { useParams } from "react-router-dom";
import { ADMIN_PASSWORD } from "../../utils/Constants";
import ProgramHeadBox from "./ProgramHeadBox";
import { GetPostFeedMessagesPaginate, readAllCommentMessages, GetMyUnreadChatNotificationCount, GetCourseStatistics, GetCourseResourceDocumentsCount, GetMySubjectsService } from "../../services/QualificationService";
import SkeletonSubjectHeadBox from "../../loaders/SekletonSubjectHeadBox";
import { clearToggles, modalOpen, setIsExamLaunched, setUnreadChatNotificationCount } from "../../store/actions";
import SubjectGroupList from "./SubjectGroupList";
import SubjectHeadBox from "../course/SubjectHeadBox";
import { FilterBar, Pill, ActivePill } from "./ProgramStyledComponents";

const Filters = [
  { key: "all", label: "All" },
  { key: "In Progress", label: "In Progress" },
  { key: "Finished", label: "Past" },
  { key: "Not Yet Published", label: "Upcoming" },
];

const ProgramContent = (props) => {
  const { qid } = useParams();
  const [finishedModules, setFinishedModules] = useState([]);
  const [otherModules, setOtherModules] = useState([]);
  const [activeFilter, setActiveFilter] = useState("In Progress");
  const [loading, setLoading] = useState(false);

  const fetchModules = async () => {
    setLoading(true);

    try {
      const res = await GetMySubjectsService({ qid });

      const subjects = res?.data?.subject || {};

      setFinishedModules(subjects?.finised ?? []);
      setOtherModules(subjects?.others ?? []);

    } catch (err) {
      console.error("Failed to fetch modules");
      setFinishedModules([]);
      setOtherModules([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchModules();
  }, [qid]);

  const modules = useMemo(() => {
    const others = otherModules;

    switch (activeFilter) {
      case "Finished":
        return finishedModules;

      case "In Progress":
        return others.filter(m => m.subjectStatus === "In Progress" || m.subjectStatus === "Not Started");

      case "Not Yet Published":
        return others.filter(m => m.subjectStatus === "Not Yet Published");

      case "all":
        return [...finishedModules, ...others];

      default:
        return others.filter(m => m.subjectStatus === "In Progress");
    }
  }, [activeFilter, finishedModules, otherModules]);

  const handleFilterChange = (key) => {
    setActiveFilter(key);
  };

  /**
   * Filter tabs based on available module data.
  */
  const visibleFilters = useMemo(() => {
    return Filters.filter((filter) => {
      switch (filter.key) {
        case "Finished":
          return finishedModules.length > 0;

        case "In Progress":
          return otherModules.some(
            (subject) =>
              subject.subjectStatus === "In Progress" ||
              subject.subjectStatus === "Not Started"
          );

        case "Not Yet Published":
          return otherModules.some(
            (subject) =>
              subject.subjectStatus === "Not Yet Published"
          );

        case "all":
          return finishedModules.length + otherModules.length > 0;

        default:
          return true;
      }
    });
  }, [finishedModules, otherModules]);

  useEffect(() => {
    const hasInProgress = visibleFilters.some(
      filter => filter.key === "In Progress"
    );

    if (hasInProgress && activeFilter !== "In Progress") {
      setActiveFilter("In Progress");
    } else if (!visibleFilters.some(filter => filter.key === activeFilter)) {
      setActiveFilter("all");
    }
  }, [visibleFilters]);

  return (
    <>
      {props?.qualification && (
        <ProgramHeadBox
          isAdmin={props?.isAdmin}
          subjectContent={props?.qualification}
          content={props?.qualification}
          updateSubject={props?.updateSubject}
          statisticsData={props?.qualification?.progress}
        />
      )}
      {loading ? <div className="py-3">{""}</div> : <FilterBar>
        {visibleFilters.map((filter) => {
          const isActive = activeFilter === filter.key;

          return isActive ? (
            <ActivePill
              key={filter.key}
              onClick={() => handleFilterChange(filter.key)}
            >
              {filter.label}
            </ActivePill>
          ) : (
            <Pill
              key={filter.key}
              onClick={() => handleFilterChange(filter.key)}
            >
              {filter.label}
            </Pill>
          );
        })}
      </FilterBar>}
      <SubjectGroupList
        setShowSideBar={props?.setShowSideBar}
        showSideBar={props?.showSideBar}
        completed_subject={props?.completed_subject}
        subjectList={modules || []}
        subjectContent={modules || []}
        updateSubject={props?.updateSubject}
        isAdmin={props?.isAdmin}
        qid={props?.qid}
        loading={loading}
      />
    </>
  );
}


function mapDispatchToProps(dispatch) {
  return {
    modalOpen: (payload) => dispatch(modalOpen(payload)),
  };
}

// export default React.memo(SubjectContent);
export default connect(mapDispatchToProps)(React.memo(ProgramContent));

